import React from "react";
import styles from "./createPackage.module.css";
import ContainerHeader from "common/ContainerHeader";
import Basic from "components/Package/Basics";

const CreatePackage = ({ package_id, data }) => {
 

  return (
    <>
      <ContainerHeader label="Create Package" showAddButton={false} />

      <div className={styles.container}>
        {/* <div
          style={{
            width: "100%",
            border: "1px solid #dcdce5",
            borderRadius: "12px",
          }}
        > */}
          <Basic package_id={package_id} data={data} />
        {/* </div> */}
      </div>
    </>
  );
};

export default CreatePackage;
